import React, { useState, useEffect } from 'react';
import ApiService from '../../../../services/apiService';
import { useTranslation } from 'react-i18next';

const SaleTaxReport = () => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState();
  const { t } = useTranslation();

  const getFormattedDate = (date) => {
    return new Date(date).toISOString().slice(0, 16); // "YYYY-MM-DDTHH:mm"
  };

  const today = new Date();
  const tenDaysAgo = new Date();
  tenDaysAgo.setDate(today.getDate() - 10);

  const [formData, setFormData] = useState({
    fromDate: getFormattedDate(tenDaysAgo),
    toDate: getFormattedDate(today),
  });

  // 🔢 Totals based on normalized keys
  const totalPaidAmount = data?.reduce((sum, row) => sum + (parseFloat(row?.totalPaidAmount) || 0), 0);
  const totalTaxAmount = data?.reduce((sum, row) => sum + (parseFloat(row?.totalTaxAmount) || 0), 0);
  const totalOrderAmount = data?.reduce((sum, row) => sum + (parseFloat(row?.totalOrderAmount) || 0), 0);

  const getReportData = async (newPageNo = pagination?.currentPage || 1) => {
    try {
      const apiService = new ApiService();
      const params = new URLSearchParams();
      params.append('ReportType', 'Sales Tax Reports');
      params.append('Measure', 'Revenue');
      params.append('StartDate', formData?.fromDate);
      params.append('EndDate', formData?.toDate);
      params.append('Comparison', 'No Comparison');

      const res = await apiService.getApiParamater('GET_SALE_SUMMERY', `?${params.toString()}`);

      const apiRows = res?.data?.result || [];

      // ✅ Normalize keys from your JSON:
      // "Payment Type", "Total Orders Amount", "Total Tax Amount", "Total Paid Amount"
      const mappedRows = apiRows.map((row) => ({
        paymentTypeName: row['Payment Type'] ?? row.PaymentTypeName ?? '---',
        totalOrderAmount: row['Total Orders Amount'] ?? row.TotalOrderAmount ?? 0,
        totalTaxAmount: row['Total Tax Amount'] ?? row.TotalTaxAmount ?? 0,
        totalPaidAmount: row['Total Paid Amount'] ?? row.TotalPaid ?? 0,
      }));

      setData(mappedRows);
      setPagination(res.data.paginationData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    getReportData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="p-5">
      <button className="btn addItem-btn mb-4" onClick={() => window.history.back()}>
        ← {t('Back')}
      </button>

      {/* <h3 className="mb-4">
        {t('sales')} {t('tax')} {t('report')}
      </h3> */}

      {/* Filters */}
      <div className="row">
        <div className="col-3">
          <label className="form-label w-50">
            {t('from')} {t('date')}
          </label>
          <input type="datetime-local" className="form-control" value={formData?.fromDate} onChange={handleInputChange} name="fromDate" />
        </div>
        <div className="col-3">
          <label className="form-label w-50">
            {t('to')} {t('date')}
          </label>
          <input type="datetime-local" className="form-control" value={formData?.toDate} onChange={handleInputChange} name="toDate" />
        </div>
        <div className="col-3 mt-3">
          <button className="mt-3 addItem-btn" type="submit" onClick={getReportData}>
            {t('search')}
          </button>
        </div>
      </div>

      {/* Report Table */}
      <div className="POsgridshad rounded p-4 mt-5">
        <div className="custom-table-container">
          <table className="custom-table">
            <thead>
              <tr>
                <th>
                  {t('payment')} {t('type')}
                </th>
                <th>
                  {t('total')} {t('orders')} {t('amount')}
                </th>
                <th>
                  {t('total')} {t('tax')} {t('amount')}
                </th>
                <th>
                  {t('total')} {t('paid')} {t('amount')}
                </th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan={4} className="text-center">
                    {t('noData') || 'No data'}
                  </td>
                </tr>
              ) : (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.paymentTypeName || '---'}</td>
                    <td>{item.totalOrderAmount?.toFixed(2)}</td>
                    <td>{item.totalTaxAmount?.toFixed(2)}</td>
                    <td>{item.totalPaidAmount?.toFixed(2)}</td>
                  </tr>
                ))
              )}
            </tbody>

            {/* Totals */}
            <tfoot>
              <tr className="bg-green-100 font-bold">
                <td colSpan={3} className="text-end">
                  {t('transaction')} {t('amount')}
                </td>
                <td>{totalOrderAmount?.toFixed(2)}</td>
              </tr>
              <tr className="bg-green-100 font-bold">
                <td colSpan={3} className="text-end">
                  {t('total')} {t('tax')}
                </td>
                <td>{totalTaxAmount?.toFixed(2)}</td>
              </tr>
              <tr className="bg-green-100 font-bold">
                <td colSpan={3} className="text-end">
                  {t('total')} {t('amount')}
                </td>
                <td>{totalPaidAmount?.toFixed(2)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SaleTaxReport;
